(() => {
  'use strict';

  /* Versión B flags, set by snippets/ses-look-vb.liquid only on look pages with the switch on. */
  const vb = window.SES_VB || {};

  function initialize(root) {
    if (root.dataset.sesReady) return;
    root.dataset.sesReady = 'true';

    root.querySelectorAll('[data-href]').forEach((link) => {
      if (link.tagName === 'A') return;
      link.setAttribute('role', 'link');
      link.tabIndex = 0;
      const label = link.getAttribute('title') || link.getAttribute('alt');
      if (label && !link.textContent.trim()) link.setAttribute('aria-label', label);
      const navigate = () => {
        const destination = new URL(link.dataset.href, window.location.href);
        if (!['https:', 'http:'].includes(destination.protocol)) return;
        if (link.dataset.target === '_blank') window.open(destination.href, '_blank', 'noopener');
        else window.location.assign(destination.href);
      };
      link.addEventListener('click', (event) => {
        if (event.target.closest('[data-href]') !== link) return;
        event.preventDefault();
        event.stopPropagation();
        navigate();
      });
      link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target === link) {
          event.preventDefault();
          event.stopPropagation();
          navigate();
        }
      });
    });

    root.querySelectorAll('[data-pf-type="ProductBox"]').forEach((box) => {
      const form = box.querySelector('form');
      const dataNode = box.querySelector('[data-ses-look-product]');
      if (!form || !dataNode) return;
      let product;
      try { product = JSON.parse(dataNode.textContent); } catch (_) { return; }
      if (!Array.isArray(product.variants)) return;
      const stockNode = form.querySelector('[data-ses-stock]');
      let stock = {};
      try { stock = JSON.parse(stockNode.textContent); } catch (_) { /* Fail closed if stock is unavailable. */ }
      product.variants.forEach((variant) => { variant.available = variant.available && stock[variant.id] > 0; });
      const controls = [...form.querySelectorAll('[data-ses-option]')];
      const options = [...new Set(controls.map((input) => Number(input.dataset.sesOption)))].map((index) => {
        const inputs = controls.filter((input) => Number(input.dataset.sesOption) === index);
        const fixed = inputs.find((input) => input.hasAttribute('data-ses-fixed-option'));
        return { index, inputs, fixedValue: fixed ? fixed.value : null };
      });
      const choices = controls.filter((input) => input.type === 'radio');
      const idInput = form.querySelector('[name="id"]');
      let pricedId = idInput ? idInput.value : '';
      const button = form.querySelector('[name="add"]');
      const status = form.querySelector('[data-ses-cart-status]');
      if (!idInput || !button) return;
      const availableLabel = 'Add To Cart';
      let pending = false;
      let selected;
      let flash = '';

      function update() {
        const values = options.map((option) => ({
          index: option.index,
          value: option.fixedValue === null ? option.inputs.find((input) => input.checked)?.value : option.fixedValue
        }));
        choices.forEach((choice) => {
          const index = Number(choice.dataset.sesOption);
          choice.disabled = !product.variants.some((variant) => variant.available &&
            variant.options[index] === choice.value &&
            values.every((option) => option.index === index || variant.options[option.index] === option.value)
          );
        });
        selected = product.variants.find((variant) =>
          values.length ? values.every((option) => variant.options[option.index] === option.value) : String(variant.id) === idInput.value
        );
        idInput.value = selected ? selected.id : '';
        button.disabled = pending || !!flash || !selected || !selected.available;
        if (vb.looks) {
          /* Versión B (vb_looks_nav): a missing combination says Unavailable, an empty one Sold out. */
          button.textContent = flash || (pending ? 'Adding…' : !selected ? 'Unavailable' :
            selected.available ? availableLabel : (button.dataset.soldout || 'Sold out'));
          choices.forEach((choice) => {
            const label = choice.id && form.querySelector('label[for="' + choice.id + '"]');
            if (label) label.setAttribute('aria-disabled', choice.disabled ? 'true' : 'false');
          });
        } else {
          button.textContent = pending ? (button.dataset.adding || 'Adding...') :
            selected && selected.available ? availableLabel : (button.dataset.soldout || 'Sold out');
        }
        if (!selected) return;

        /* The price is already rendered by Liquid for the initial variant: only rewrite it when the variant changes. */
        if (String(selected.id) !== pricedId) {
          pricedId = String(selected.id);
          const formatMoney = window.theme && window.theme.Currency && window.theme.Currency.formatMoney;
          form.querySelectorAll('[data-product-type="price"]').forEach((price) => {
            if (formatMoney) price.innerHTML = formatMoney(selected.price, window.theme.settings.moneyFormat);
            else price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency', currency: root.dataset.currency || 'EUR'
            }).format(selected.price / 100);
            /* Versión B (vb_precio_formato): €235 instead of €235,00, like money_without_trailing_zeros. */
            if (vb.price && selected.price % 100 === 0) price.innerHTML = price.innerHTML.replace(/[.,]00(?!\d)/, '');
          });
        }
        const slides = [...box.querySelectorAll('.pf-main-media .pf-slide-main-media')];
        const mediaId = selected.featured_media && selected.featured_media.id;
        const source = selected.featured_image && selected.featured_image.src;
        const active = slides.find((slide) => mediaId && String(mediaId) === slide.dataset.mediaId) ||
          slides.find((slide) => source && [...slide.querySelectorAll('img')].some((img) =>
            img.getAttribute('src').split('?')[0] === source.split('?')[0]
          )) || slides[0];
        slides.forEach((slide) => { slide.hidden = slide !== active; });
        box.querySelectorAll('.product-media-loading').forEach((media) => media.classList.remove('product-media-loading'));
        box.querySelectorAll('[data-pf-type="MediaMain"][data-href]').forEach((media) => {
          media.dataset.href = product.url + '?variant=' + selected.id;
        });
      }

      choices.forEach((choice) => choice.addEventListener('change', () => {
        status.hidden = true;
        update();
      }));
      const configured = product.variants.find((variant) => String(variant.id) === idInput.value);
      if (!configured || !configured.available) {
        const firstAvailable = product.variants.find((variant) => variant.available &&
          options.every((option) => option.fixedValue === null || variant.options[option.index] === option.fixedValue)
        );
        if (firstAvailable) choices.forEach((choice) => {
          choice.checked = choice.value === firstAvailable.options[Number(choice.dataset.sesOption)];
        });
      }
      update();

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || flash || !selected || !selected.available) return;
        pending = true;
        status.hidden = true;
        update();
        try {
          const routes = window.theme && window.theme.routes;
          const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(routes && routes.cartAdd || rootUrl + 'cart/add.js', {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
          if (vb.looks) flash = 'Added ✓';
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true, detail: { product: result, addToCartBtn: button }
          }));
          /* Versión B (vb_looks_nav): refresh the drawer and the cart count, as the product page does. */
          if (vb.looks) document.dispatchEvent(new CustomEvent('cart:build'));
          if (!document.getElementById('CartDrawer') || window.theme.settings.cartType === 'page') {
            window.location.assign(routes && routes.cartPage || rootUrl + 'cart');
          }
        } catch (error) {
          if (vb.looks) flash = 'Try again';
          status.textContent = error.message;
          status.hidden = false;
        } finally {
          pending = false;
          update();
          if (flash) setTimeout(() => { flash = ''; update(); }, flash === 'Try again' ? 2200 : 1600);
        }
      });
    });
  }

  function initializeAll(scope = document) {
    if (scope.matches && scope.matches('[data-ses-native-page]')) initialize(scope);
    scope.querySelectorAll('[data-ses-native-page]').forEach(initialize);
  }
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
